import React from 'react';
import PropTypes from 'prop-types';
import isNaN from 'lodash/isNaN';
import { ValidatedTextInput } from '@els/els-react--text-input';

function GoToPage({ chunksCount, onClick }) {
  const [inputValue, setInputValue] = React.useState('');
  const inputRef = React.useRef(null);

  const validateInputValue = (valueAsInteger) => {
    if (isNaN(valueAsInteger)) {
      return false;
    }

    if (valueAsInteger > chunksCount) {
      return false;
    }

    return valueAsInteger !== 0;
  };

  const goToHandler = () => {
    const valueAsInteger = parseInt(inputValue, 10);

    if (!validateInputValue(valueAsInteger)) return;

    // Clear synchronously before navigation so the re-render completes before
    // ResultsContainerBase shifts focus to the results list. A post-navigation
    // setInputValue (previously done in a useEffect) caused a DOM mutation that
    // dropped focus to document.body, making VoiceOver announce the page title.
    setInputValue('');
    onClick(valueAsInteger);
  };

  const onChange = (e) => {
    const { value } = e.target;
    const valueAsInteger = parseInt(value, 10);
    const newInputValue = isNaN(valueAsInteger) ? '' : valueAsInteger;
    setInputValue(newInputValue);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      goToHandler();
    }
  };

  const isValidInputValue = validateInputValue(parseInt(inputValue, 10));

  return (
    <div>
      <ValidatedTextInput
        inputRef={inputRef}
        iconRight={{
          id: 'goToPage',
          sprite: 'ChevronRight',
          color: isValidInputValue ? 'secondary' : undefined,
          children: 'Go to page',
        }}
        label="Go to page"
        data-e2e="go-to-page-input"
        shouldHideLabel
        min={1}
        max={chunksCount}
        validator={(value) => {
          if (value === '' || value === undefined) return null;
          const n = Number.parseInt(value, 10);
          if (Number.isNaN(n)) return null;
          if (n < 1 || n > chunksCount) {
            return `Please enter a page number between 1 and ${chunksCount}`;
          }
          return null;
        }}
        value={inputValue}
        className="bar-chart-checkboxes-dialog__go-to-page"
        onKeyDown={onKeyDown}
        iconRightCallback={goToHandler}
        onChange={onChange}>
        {null}
      </ValidatedTextInput>
    </div>
  );
}

GoToPage.propTypes = {
  chunksCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default GoToPage;
